/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue';
import * as types from './mutation-types';

export const getAccount = ({ commit }, token) => {
  const requestConfig = token ? { headers: { Authorization: token } } : {};

  Vue.$http
    .get('users/me', requestConfig)
    .then((response) => {
      const user = response.data.user;
      commit(types.GET_ACCOUNT, user);
    })
    .catch((error) => {
      console.log(error);
    });
};

// Auth
export const login = ({ commit }, token) => {
  commit(types.LOGIN, token);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const checkAuthentication = ({ commit }) => {
  commit(types.CHECK_AUTHENTICATION);
};

export default {
  checkAuthentication,
  login,
  logout,
  getAccount,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js